const PlusBold = () => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 24 24' fill='none'>
			<path
				d='M4 12C4 11.7069 4.10514 11.4552 4.31541 11.2449C4.52569 11.0283 4.77738 10.92 5.07049 10.92H10.9295V5.07049C10.9295 4.77738 11.0346 4.52569 11.2449 4.31541C11.4552 4.10514 11.7069 4 12 4C12.2995 4 12.5544 4.10514 12.7646 4.31541C12.9749 4.52569 13.08 4.77738 13.08 5.07049V10.92H18.9295C19.2226 10.92 19.4743 11.0283 19.6846 11.2449C19.8949 11.4552 20 11.7069 20 12C20 12.2995 19.8949 12.5544 19.6846 12.7646C19.4743 12.9685 19.2226 13.0705 18.9295 13.0705H13.08V18.9391C13.08 19.2258 12.9749 19.4743 12.7646 19.6846C12.5544 19.8949 12.2995 20 12 20C11.7069 20 11.4552 19.8949 11.2449 19.6846C11.0346 19.4743 10.9295 19.2258 10.9295 18.9391V13.0705H5.07049C4.77738 13.0705 4.52569 12.9685 4.31541 12.7646C4.10514 12.5544 4 12.2995 4 12Z'
				fill='#21242D'
			/>
		</svg>
	);
};

export default PlusBold;
